const styles = {
  legend: {
    textAlign: 'center !important',
    marginTop: '3em !important',
  },
  labelSeries: {
    stroke: '#fffdfd63',
    transform: 'translate(2.5em, -2em)',
    fontSize: '0.8em !important',
  },
  charts: {
    '& .rv-xy-plot__series--line': {
      pointerEvents: 'none !important',
    },
  },
};

export default styles;
